module.exports = __webpack_public_path__ + "media/new/coming-soon-6ab3c26e.gif";